var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1987_21847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 64,
    height: 64,
    rx: 32,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 18.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#01B9FD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.875 34C50.25 34 50.625 34 51 34C52.4788 34.5186 53.0726 35.5603 52.7813 37.125C52.5198 37.8449 52.0406 38.3657 51.3438 38.6875C51.3125 39.2496 51.3021 39.8121 51.3125 40.375C54.4792 40.375 57.6458 40.375 60.8125 40.375C60.8229 39.8121 60.8125 39.2496 60.7813 38.6875C59.4884 38.0624 59.0092 37.0416 59.3438 35.625C59.6533 34.7631 60.247 34.2214 61.125 34C61.4792 34 61.8333 34 62.1875 34C63.5899 34.4693 64.2044 35.4484 64.0312 36.9375C63.7986 37.7532 63.2986 38.3365 62.5312 38.6875C62.5 39.2496 62.4896 39.8121 62.5 40.375C64.5404 40.2021 66.03 41.0146 66.9688 42.8125C67.169 43.3139 67.2732 43.8348 67.2812 44.375C67.3229 48.9375 67.3229 53.5 67.2812 58.0625C67.1336 60.1602 66.0398 61.4624 64 61.9688C62.2292 61.9896 60.4583 62.0104 58.6875 62.0312C56.5793 63.3557 54.4751 64.6786 52.375 66C52.1667 66 51.9583 66 51.75 66C51.5221 65.9073 51.3658 65.7406 51.2813 65.5C51.25 64.3335 51.2396 63.1669 51.25 62C50.2081 62.0104 49.1664 62 48.125 61.9688C46.2255 61.5068 45.1318 60.3089 44.8438 58.375C44.8021 53.6042 44.8021 48.8333 44.8438 44.0625C45.0169 42.5173 45.7981 41.4027 47.1875 40.7188C47.9725 40.4159 48.785 40.3013 49.625 40.375C49.6354 39.8121 49.625 39.2496 49.5938 38.6875C48.2122 38.0024 47.7538 36.919 48.2188 35.4375C48.5517 34.6978 49.1038 34.2187 49.875 34ZM51.625 45.25C53.255 45.1795 54.1925 45.9503 54.4375 47.5625C54.2907 48.2922 53.874 48.5109 53.1875 48.2188C53.0907 48.1429 53.0178 48.0491 52.9688 47.9375C52.9197 47.6347 52.8364 47.343 52.7188 47.0625C51.8035 46.5306 51.2826 46.8015 51.1563 47.875C50.7966 48.4522 50.3591 48.5147 49.8438 48.0625C49.6005 47.1254 49.8609 46.3442 50.625 45.7188C50.9401 45.5089 51.2735 45.3527 51.625 45.25ZM59.625 45.25C61.2544 45.1793 62.1919 45.9501 62.4375 47.5625C62.2907 48.2922 61.874 48.5109 61.1875 48.2188C60.9506 47.9666 60.8359 47.6646 60.8438 47.3125C60.5877 46.8396 60.2023 46.6833 59.6875 46.8438C59.5759 46.8928 59.4821 46.9657 59.4063 47.0625C59.2838 47.3201 59.2004 47.5909 59.1563 47.875C58.7937 48.4528 58.3562 48.5153 57.8438 48.0625C57.5754 47.1173 57.8359 46.3361 58.625 45.7188C58.9401 45.5089 59.2735 45.3527 59.625 45.25ZM50.3125 53.625C50.4857 53.6201 50.6523 53.6513 50.8125 53.7188C52.0768 54.3265 53.4101 54.6807 54.8125 54.7812C57.1991 54.9996 59.4804 54.6143 61.6562 53.625C62.3757 53.7947 62.5736 54.2113 62.25 54.875C62.1574 54.9363 62.0741 55.0092 62 55.0938C58.8679 56.4904 55.6388 56.7613 52.3125 55.9062C51.4343 55.6833 50.6113 55.3396 49.8438 54.875C49.5646 54.2884 49.7209 53.8717 50.3125 53.625Z",
    fill: "#01B9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 52.4995C40 51.3745 40 50.2495 40 49.1245C40.1053 47.9455 40.7303 47.1851 41.875 46.8433C42.3516 46.7719 42.8308 46.7406 43.3125 46.7495C43.3125 49.437 43.3125 52.1245 43.3125 54.812C42.256 55.0093 41.3497 54.7384 40.5938 53.9995C40.253 53.549 40.055 53.049 40 52.4995Z",
    fill: "#01B9FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 48.437C72 49.9995 72 51.562 72 53.1245C71.6918 53.9891 71.0876 54.5411 70.1875 54.7807C69.7296 54.812 69.2713 54.8224 68.8125 54.812C68.8125 52.1245 68.8125 49.437 68.8125 46.7495C69.8702 46.5987 70.7765 46.8904 71.5312 47.6245C71.7216 47.8809 71.8779 48.1517 72 48.437Z",
    fill: "#01B9FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1987_21847",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.115741 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1987_21847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1987_21847",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.37fcfc9bcbcc9d39793566f3d76cfd69.svg";
export { ForwardRef as ReactComponent };